export const convertTimeDuration = (DurationInMS) => {
  const hours = Math.floor(DurationInMS / 3600000);
  const minutes = Math.floor((DurationInMS % 3600000) / 60000);
  const seconds = Math.floor((DurationInMS % 60000) / 1000);
  return `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
};
